import { Modal } from 'antd';
import React, { useState } from 'react';
import { AprovarCancelamentoBm, CancelarBmPeloDropdown } from '@app/api/boletimMedicao';
import { Button, Icon } from '@digital/ui';
import TextArea from 'antd/lib/input/TextArea';

export interface PropsModalComentario {
  id: string;
  onUpdatePage: () => any;
  setMedicaoConfirmada: () => any;
  setShowModalCancelarMedicao: () => any;
}

const ModalJustificativaCancelamentoMedicaoPeloDropdown = (props: PropsModalComentario) => {
  const { id, onUpdatePage, setMedicaoConfirmada, setShowModalCancelarMedicao } = props;
  const textAreaId = `textAreaId${id}`;
  const [justificativa, setJustificativa] = useState('');

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  const handleCancel = () => {
    limparCampo();
    setShowModalCancelarMedicao(false);
    setMedicaoConfirmada(null);
  };

  const Salvar = (e: any) => {
    CancelarBmPeloDropdown(id, { medicaoId: id, justificativaCancelamentoMedicao: justificativa }).then(data => {
      if (data) {
        limparCampo();
        if (data.valid) {
          onUpdatePage();
        }
      }
    });
  };

  return (
    <>
      <Modal
        title="Justificativa Cancelamento Medição"
        className="chat-modal"
        visible={true}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submit" type="link" onClick={e => Salvar(e)}>
            Enviar
          </Button>,
          <Button key="cancel" type="primary" onClick={() => handleCancel()}>
            Fechar
          </Button>,
        ]}>
        <TextArea
          name="justificativa"
          id="justificativa"
          onChange={value => {
            setJustificativa(value.currentTarget.value);
          }}
          placeholder="informe a justificativa"
          rows={3}
        />
      </Modal>
    </>
  );
};

export default ModalJustificativaCancelamentoMedicaoPeloDropdown;
